import { render, staticRenderFns } from "./automationCampaign.vue?vue&type=template&id=23f7494b"
import script from "./automationCampaign.vue?vue&type=script&lang=js"
export * from "./automationCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports